import React, { useEffect } from 'react';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Testimonials = () => {
  useEffect(() => {
    const swiper = new Swiper('.swiper', {
      autoHeight: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      modules: [Navigation, Pagination],
    });
    
    // IMPORTANT: You need to destroy the Swiper instance when the component unmounts
    return () => {
      swiper.destroy();
    };
  }, []);

  return (
    <div id="page" className="site">
      <div className="container">
        <div className="testi">
          <div className="head">
            <h3>Testimonials</h3>
            <p>See What People are saying..</p>
          </div>
          <div className="body swiper">
            <ul className="swiper-wrapper">
              <li className="swiper-slide">
                <div className="wrapper">
                  <div className="thumbnail">
                    <img src="https://res.cloudinary.com/debltnmge/image/upload/v1691774001/271-2711764_girl-image-in-circle-hd-png-download_a8qfuf.png" alt="" />
                  </div>
                  <div className="aside">
                    <p>
                    JourneyScape crafted my Pakistan odyssey to perfection. From the mystical alleys of Lahore to the majestic mountains of Gilgit-Baltistan, each day felt like a fairy tale. Impeccable planning, warm hospitality – they made my journey extraordinary.
                    </p>
                    <div className="name">
                      <h4>Sarah</h4>
                      <p>Tourist</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className="swiper-slide">
                <div className="wrapper">
                  <div className="thumbnail">
                    <img src="https://res.cloudinary.com/debltnmge/image/upload/v1691773795/906-9060938_testimonial-circle-girl_wz0lqz.jpg" alt="" />
                  </div>
                  <div className="aside">
                    <p>
                    JourneyScape etched Pakistan in my heart in ways I didn't anticipate. Their knack for detail made every encounter, every panorama, unforgettable. This adventure was more than a trip – it was an artistically woven tapestry of experiences.
                    </p>
                    <div className="name">
                      <h4>Maya</h4>
                      <p>Tourist</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className="swiper-slide">
                <div className="wrapper">
                  <div className="thumbnail">
                    <img src="https://res.cloudinary.com/debltnmge/image/upload/b_rgb:ffffff/v1691774482/38_hbbbuu.png" alt="" />
                  </div>
                  <div className="aside">
                    <p>
                    Embarking on Pakistan's expedition with JourneyScape was the best decision. Their well-orchestrated itinerary let me savor every bit of this diverse land. The blend of history, nature, and culture was seamless – an escapade I'll nostalgically relive.
                    </p>
                    <div className="name">
                      <h4>Amir</h4>
                      <p>Tourist</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
